import { Card, Col, Row, Table } from "react-bootstrap";
import { currencyFormat } from "../../../helpers/numericFields";

export const OwnerFeeSummary = ({ ownerFeeSummary }) => {

  return (
    <div style={{marginTop:20}}>
      <Row>
        <Col sm={4} className="col-4">
          <Card>
            <Card.Header>
              <h3 className="card-title mb-0">Acumulado Invitados</h3>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive">
                <Table className="table text-nowrap text-md-nowrap mg-b-0">
                  <thead>
                    <tr>
                      <th>Expedientes</th>
                      <th>Acumulado</th>                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr >
                      <td>{ownerFeeSummary.individualFiles || 0}</td>
                      <td>{currencyFormat(ownerFeeSummary.accumulated || 0)}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  )
}
